import type { SVGProps } from "react";
import * as React from "react";

const SvgHash = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M4 8a1 1 0 0 0 0 2zm16 2a1 1 0 1 0 0-2zM4 14a1 1 0 1 0 0 2zm16 2a1 1 0 1 0 0-2zM10.994 3.11a1 1 0 0 0-1.988-.22zM7.006 20.89a1 1 0 1 0 1.988.22zm9.988-17.78a1 1 0 0 0-1.988-.22zm-3.988 17.78a1 1 0 0 0 1.988.22zM4 10h16V8H4zm0 6h16v-2H4zM9.006 2.89l-2 18 1.988.22 2-18zm6 0-2 18 1.988.22 2-18z"
    />
  </svg>
);
export default SvgHash;
